import { LuDatetimePickerConfig, LuDatetimePickerPlacement } from './lu-datetime-picker.models';
import { TimeOptions } from './time-options.model';

function generateUniqueId(): string {
	return Math.random().toString(36).substring(2);
}

export const defaultLuDatetimePickerConfig: LuDatetimePickerConfig = {
	primaryId: generateUniqueId(),
	primaryTimePickerId: generateUniqueId(),
	secondaryId: generateUniqueId(),
	secondaryTimePickerId: generateUniqueId(),
	timeOptions: new TimeOptions(),
	placeholderFrom: '',
	placeholderTo: '',
	labelDatePicker: '',
	labelTimePicker: '',
	labelDateRangeTo: '',
	labelTimePickerTo: '',
	dateRange: false,
	primaryRequired: true,
	secondaryRequired: true,
	inlineDatePicker: true,
	primaryRequiredMessage: 'jqueryvalidation.date',
	secondaryRequiredMessage: 'jqueryvalidation.date',
	datepickerColsClass: 'sm-6',
	timepickerColsClass: 'sm-6',
	hideTimepicker: false,
	hideDatepicker: false,
	localeDateTime: false,
	dateFormat: 'mediumDate',
	placement: LuDatetimePickerPlacement.AUTO
};
